// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"84":"how-to-mint","9650":"how-to-create-a-wallet"}[chunkId] + "." + {"84":"f04eafb4","9650":"30e4b210"}[chunkId] + ".css";
};